import React, { useState, useEffect } from "react";
import { Table, Button, Pagination, message, Image } from "antd";
import ContentGroupModal from "../pages/ContentGroupModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { binaryContentsHooks as cHooks } from "../hooks";

const StoryLayout = () => {
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [isGroupModalVisible, setIsGroupModalVisible] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get("page"), 10) || 1;
  const navigate = useNavigate();

  // 콘텐츠 목록 불러오기
  const fetchContents = async (page) => {
    setLoading(true);
    try {
      const res = await cHooks.storyList({ page: page });
      setContents(res.data.data || []);
      setTotal(res.data.cnt || 0);
    } catch (error) {
      message.error("콘텐츠 목록 불러오기 실패!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContents(currentPage);
  }, [currentPage]);

  const columns = [
    {
      title: "제목",
      dataIndex: "story_title",
    },
    {
      title: "썸네일",
      dataIndex: "content_thumbnail",
      render: (url) => <Image src={url} alt="썸네일" width={60} height={60} />,
    },
    {
      title: "상세보기",
      render: (_, record) => (
        <Button
          onClick={() =>
            navigate("/dpcontents/edit", {
              state: { contentData: record, page: currentPage }, // 콘텐츠 데이터를 전달
            })
          }
        >
          상세보기
        </Button>
      ),
    },
  ];

  return (
    <div>
      {/* 버튼 컨트롤 */}
      

      {/* 콘텐츠 목록 */}
      <Table
        columns={columns}
        dataSource={contents}
        rowKey="id"
        loading={loading}
        pagination={false}
      />

      {/* 페이지네이션 */}
      <Pagination
        current={currentPage}
        total={total}
        pageSize={10}
        onChange={(page) => setSearchParams({ page })}
        style={{ marginTop: "20px", textAlign: "center" }}
      />

      {/* 그룹 모달 */}
      <ContentGroupModal
        visible={isGroupModalVisible}
        onClose={() => setIsGroupModalVisible(false)}
      />
    </div>
  );
};

export default StoryLayout;
